import { computed } from 'vue';
import { useWindowSize } from '@vueuse/core';

// Breakpoints to match Design System Guidelines: https://www.sap.com/design-system/digital/foundations/layout/grid-breakpoints/

const screenSizes = Object.freeze({
  xs: 360, // XS: 360px - 639px (Small mobile devices)
  sm: 640, // S: 640px - 979px (Mobile devices)
  md: 980, // M: 980px - 1279px (Tablets and small laptops)
  lg: 1280, //* L: 1280px - 1599px (Desktop computers)
  xl: 1600, //* XL: 1600px+ (Large desktop screens)
});

export const useScreenSize = () => {
  const { width: windowWidth } = useWindowSize();

  return {
    isScreenSizeMoreXS: computed(() => windowWidth.value > screenSizes.xs),
    isScreenSizeLessSM: computed(() => windowWidth.value < screenSizes.sm),
    isScreenSizeMoreSM: computed(() => windowWidth.value >= screenSizes.sm),
    isScreenSizeLessMD: computed(() => windowWidth.value < screenSizes.md),
    isScreenSizeMoreMD: computed(() => windowWidth.value >= screenSizes.md),
    isScreenSizeLessLG: computed(() => windowWidth.value < screenSizes.lg),
    isScreenSizeMoreLG: computed(() => windowWidth.value > screenSizes.lg),
    isScreenSizeLessXL: computed(() => windowWidth.value < screenSizes.xl),
    isScreenSizeMoreXL: computed(() => windowWidth.value >= screenSizes.xl),
  };
};

export default useScreenSize;
